<template>
  <div class="container">
    <img class="img" :src="imgSrc" alt="">
    <h4 class="title">{{title}}</h4>
    <div class="text">
      <span v-html="resultText"></span>
      <a v-show="isShowTel" :href="'tel:'+tel">{{tel}}</a>
    </div>
    <div v-if="showSubmit" class="submit_btn" @click="submit">重新支付</div>
  </div>
</template>

<script>
  import {env} from '@/config/env'

  export default {
    name: "pay-result",
    data() {
      return {
        state: 'loading',
        resultText: '支付申请已提交，请耐心等待15秒！',
        tel: env === 'bkb' ? '400-1002-721' : '400-0707-511',
        second: 15,
        timer: null
      }
    },
    watch: {
      second(val) {
        if (val === 0) {
          clearInterval(this.timer)
          return this.getPayResult('end')
        }
        if (val === 10) {
          this.getPayResult()
        }
      }
    },
    computed: {
      isShowTel() {
        return this.state === 'fail' || this.state === 'pending'
      },
      showSubmit() {
        return this.state === 'fail'
      },
      imgSrc() {
        const src = {
          loading: 'pay_loading',
          fail: 'icon_fault'
        }
        return require(`./static/images/${src[this.state] || src.loading}.svg`)
      },
      title() {
        return this.state === 'fail' ? '支付失败了！' : ''
      }
    },
    mounted() {
      this.getPayResult()
      this.timer = setInterval(() => {
        this.resultText = `支付申请已提交，请耐心等待${this.second--}秒！`
      }, 1000)
    },
    methods: {
      getPayResult(state) {
        const {orderNo} = this.$route.query
        const url = `/queryOrderStatus/${orderNo}`
        this.axios.post(url).then(({data, message}) => {
          // 1 处理中 2 成功 0 失败 -1 查询异常
          if (data === 2) {
            this.paySuccess(this.$route.query)
          } else if (data === 1) {
            if (state === 'end') {
              this.state = 'pending'
              this.resultText = '支付申请已提交，请耐心等待！如您<br/>需要帮助，可拨打客服热线：'
            }
          } else {
            clearInterval(this.timer)
            this.state = 'fail'
            this.resultText = `失败信息：${message}，<br/>如您需要帮助，可拨打客服热线：`
            // this.resultText = '失败信息：BF00436交易类型不存在，如您<br/>需要帮助，可拨打客服热线：'
          }
        }, () => {
          clearInterval(this.timer)
          this.state =  'fail'
          this.resultText = `失败：，<br/>如您需要帮助，可拨打客服热线： `
        })
      },
      paySuccess({applicationType, id, self, fullPath}) {
        if (fullPath === '/loan/decompression-material-pay' ) {
          // 解押 applyId id 反过来传
          const path = '/loan/decompression-material-result?id=-1&noticeArchives=0&applyId='+id
          return this.$router.push(path);
        }
        if (Number(applicationType) === 0) {
          // 抵押
          this.$router.push('/loan/mortgage-evaluate?id=' + id);
        } else {
          // 解押
          if (Number(self) === 1) {
            this.$router.push('/loan/decompression-self?id=' + id + '&noticeArchives=0');
          } else {
            this.$router.push('/loan/decompression-evaluate?id=' + id + '&noticeArchives=0');
          }
        }
      },
      submit() {
        this.$router.back()
      }
    }
  }
</script>

<style scoped lang="scss">
  .container {
    padding-top: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .title {
      font-size: 28px;
      font-family: PingFang HK, PingFang HK-Regular;
      margin-bottom: 32px;
      color: #000000;
    }

    .img {
      margin-bottom: 64px;
    }

    .text {
      font-size: 28px;
      font-family: PingFang HK, PingFang HK-Regular;
      color: #5b6679;
      line-height: 44px;

      a {
        color: #008DF6;
        text-decoration: none;
      }
    }

    .submit_btn {
      background: #008df6;
      border-radius: 8px;
      font-size: 28px;
      line-height: 80px;
      text-align: center;
      margin-top: 96px;
      color: #f8f8f8;
      width: 50%;
    }
  }
</style>
